// Lógica pura da edição de composição de um grupo De/Para (sem React, fácil de testar).

export interface DiferencaComposicao {
  adicionadas: number[];
  removidas: number[];
  houveMudanca: boolean;
}

/** Compara a composição original do grupo com a final escolhida pelo usuário. */
export const diferencaComposicao = (original: Iterable<number>, final: Iterable<number>): DiferencaComposicao => {
  const o = new Set(original);
  const f = new Set(final);
  const adicionadas = Array.from(f).filter(id => !o.has(id));
  const removidas = Array.from(o).filter(id => !f.has(id));
  return { adicionadas, removidas, houveMudanca: adicionadas.length > 0 || removidas.length > 0 };
};

export interface ContaBuscavel {
  contaId: number;
  codigo: string;
  descricao: string;
}

/** Contas que ainda podem ser incluídas: fora da composição atual e que casam com a busca. */
export const candidatasParaInclusao = <T extends ContaBuscavel>(
  elegiveis: T[],
  naComposicao: Set<number>,
  busca: string,
  limite = 50,
): { itens: T[]; total: number } => {
  const q = busca.trim().toLowerCase();
  const todas = elegiveis.filter(c =>
    !naComposicao.has(c.contaId)
    && (!q || c.codigo.toLowerCase().includes(q) || c.descricao.toLowerCase().includes(q)));
  return { itens: todas.slice(0, limite), total: todas.length };
};
